import { formikFormData } from '@/utils/helpers/formikFormData';

import useApi from '../api';

const useReportService = () => {
    const { api } = useApi();

    return {
        create: (data) => {
            return api.post('report', data).then((resp) => resp.data);
        },
        update: (data, id) => {
            return api.put(`report/${id}`, data).then((resp) => resp.data);
        },
        delete: (reportId) => api.delete(`report/${reportId}`).then((resp) => resp.data),
        getAllReports: (params) =>
            api
                .get('report/', {
                    headers: { 'Content-Type': 'application/json' },
                    params
                })
                .then((resp) => resp.data),
        getReportPerId: (id) =>
            api
                .get(`report/${id}`, {
                    params: {
                        viewAsConsultant: sessionStorage.getItem('consultant_id')
                    }
                })
                .then((resp) => resp.data),
        showReportPDFPerId: (id) => api.get(`report/${id}/pdf`, { responseType: 'blob' }).then((resp) => resp.data),
        addReportApprovalFiles: (data) => api.post('report_approval_files', formikFormData(data)).then((resp) => resp.data),
        getReportsPerConsultant: (id, year, month, currentUserRole) =>
            api
                .get(`report/get_properties_reports/${id}`, {
                    params: {
                        year,
                        month,
                        currentUserRole
                    }
                })
                .then((resp) => resp.data),
        getCountReportsPerMonth: (id, year, currentUserRole) =>
            api
                .get(`report/get_reports_month/${id}`, {
                    params: {
                        year: year,
                        currentUserRole
                    }
                })
                .then((resp) => resp.data),

        updateReportActionPlanData: (payload, reportId, isEditing) =>
            api.put(`report/update_action_plan_data/${reportId}`, {
                ...payload,
                isEditing
            }),
        getReportsPerConsultantZip: (enterprise_id, year, month) =>
            api.post(`/report_approval_files/generate-enterprise-zip/`, {
                enterprise_id,
                year,
                month
            }),
        updateReleased: (reportId, released) => api.patch(`report/${reportId}/released`, { released }).then((resp) => resp.data),
        checkNewMonthlyReport: (enterpriseId) =>
            api.get('monthly-reports/check-new', { params: { enterprise_id: enterpriseId } }).then((resp) => resp.data),
        markMonthlyReportViewed: (enterpriseId, reportDate) =>
            api.post('monthly-reports/mark-viewed', { enterprise_id: enterpriseId, report_date: reportDate }).then((resp) => resp.data),
        downloadLatestMonthlyReport: (enterpriseId) =>
            api
                .get('monthly-reports/download-latest', { params: { enterprise_id: enterpriseId }, responseType: 'blob' })
                .then((resp) => resp.data),
        // ========== MODO EMAIL (temporário) ==========
        // downloadMonthlyClosingReports: (enterpriseId) =>
        //  api.get('reports/download-monthly-closing', { params: { enterprise_id: enterpriseId } }).then((resp) => resp.data),
        // ========== MODO DOWNLOAD INSTANTÂNEO (usar após 30 dias) ==========
        downloadMonthlyClosingReports: (enterpriseId) =>
            api
                .get('reports/download-monthly-closing', { params: { enterprise_id: enterpriseId }, responseType: 'blob' })
                .then((resp) => resp),
        uploadImage: (imageFile) => {
            const formData = new FormData();
            formData.append('image', imageFile);
            return api
                .post('report/upload-image', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then((resp) => resp.data);
        },
        getDashboard: (enterpriseId, filters = {}) =>
            api
                .get(`report/dashboard/${enterpriseId}`, {
                    params: filters
                })
                .then((resp) => resp.data),
        exportReportsTableExcel: (enterpriseId, filters = {}) =>
            api.get(`report/dashboard/${enterpriseId}/export-reports`, {
                params: filters,
                responseType: 'blob'
            }),
        exportConsultantsTableExcel: (enterpriseId, filters = {}) =>
            api.get(`report/dashboard/${enterpriseId}/export-consultants`, {
                params: filters,
                responseType: 'blob'
            }),
        getDrafts: (reportId) => api.get(`reports/${reportId}/drafts`).then((resp) => resp.data)
    };
};

export default useReportService;
